// import React, { useState } from 'react';
// import { useParams, Link, useNavigate } from 'react-router-dom'
// import { useDispatch, useSelector } from 'react-redux'
// import axios from 'axios';

// const CancelSubscription = () => {
//     const { id } = useParams()
//     const { email, idToken } = useSelector((state) => state.auth);

//     const [error, setError] = useState(null);
//     const [processing, setProcessing] = useState(false);
//     const [succeeded, setSucceeded] = useState(false);

//     const handleSubmit = async (event) => {
//         event.preventDefault();
//         setProcessing(true);

//         try {
//             // Call your server to cancel the subscription
//             const url = `https://szzfbdwon6.execute-api.us-east-2.amazonaws.com/DEV/stripesubscriptioncancel`
//             const config = {
//                 "headers": {
//                     "Authorization": idToken
//                 }
//             }

//             const data = {
//                 subscriptionId: id
//             }

//             const response = await axios.post(
//                 url, data, config
//             );

//             if (response.data.status === 'canceled') {
//                 setError(null);
//                 setSucceeded(true);
//                 setProcessing(false);
//             } else {
//                 setError('Failed to cancel subscription: ' + response.data.message);
//                 setProcessing(false);
//             }
//         } catch (err) {
//             setError('Failed to cancel subscription: ' + err.message);
//             setProcessing(false);
//         }
//     };

//     return (
//         <div className='min-h-64 px-4 py-6'>
//             <div className="container-xl lg:container m-auto px-4 py-6">
//                 <div className='text-2xl text-center font-semibold mb-6 uppercase'>Cancel Subscription</div>
//                 <form onSubmit={handleSubmit}>
//                     <div className="font-bold text-xl">Do you want to cancel your subscription?</div>

//                     {error && <div style={{ color: 'red' }}>{error}</div>}
//                     {succeeded && <div style={{ color: 'green' }}>Subscription successfully canceled!</div>}
//                     {/* <button type="submit" disabled={processing || !id}>
//                         {processing ? 'Processing...' : 'Cancel Subscription'}
//                     </button> */}
//                     <button type="submit" disabled={processing || !id} className='w-[150px] h-[36px] bg-red-500 hover:bg-red-600 text-white rounded-lg text-center text-sm mb-2' >
//                         {processing ? 'Processing...' : 'Cancel Subscription'}
//                     </button>
//                 </form>
//             </div>
//         </div>
//     );

// }

// export default CancelSubscription

import React, { useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';

const CancelSubscription = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { email, idToken } = useSelector((state) => state.auth);

    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [succeeded, setSucceeded] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setProcessing(true);

        try {
            const url = `https://szzfbdwon6.execute-api.us-east-2.amazonaws.com/DEV/stripesubscriptioncancel`;
            const config = {
                headers: {
                    Authorization: idToken
                }
            };

            const data = {
                subscriptionId: id
            };

            const response = await axios.post(url, data, config);

            if (response.data.status === 'canceled') {
                setError(null);
                setSucceeded(true);
                setProcessing(false);
                // Redirect after 2 seconds
                setTimeout(() => navigate('/sub'), 2000);
            } else {
                setError('Failed to cancel subscription: ' + response.data.message);
                setProcessing(false);
            }
        } catch (err) {
            setError('Failed to cancel subscription: ' + err.message);
            setProcessing(false);
        }
    };

    return (
        <div className="max-w-md mx-auto min-h-64 px-4 py-8">
            <div className="flex items-center mb-6">
                <Link
                    to="/sub/"
                    className="flex items-center text-blue-600 hover:text-blue-800 transition-colors"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd" />
                    </svg>
                    Back to Subscriptions
                </Link>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="bg-red-50 p-6 border-b border-red-100">
                    <h1 className="text-2xl font-bold text-center text-gray-800">
                        Cancel Subscription
                    </h1>
                </div>

                <div className="p-6">
                    {!succeeded ? (
                        <div className="space-y-6">
                            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <svg className="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2h-1V9a1 1 0 00-1-1z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <div className="ml-3">
                                        <p className="text-sm text-yellow-700">
                                            Are you sure you want to cancel your subscription? You will lose access to all premium features when your current billing period ends.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <form onSubmit={handleSubmit} className="space-y-4">
                                {error && (
                                    <div className="bg-red-50 border-l-4 border-red-400 p-4">
                                        <div className="flex">
                                            <div className="flex-shrink-0">
                                                <svg className="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                                </svg>
                                            </div>
                                            <div className="ml-3">
                                                <p className="text-sm text-red-700">{error}</p>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="flex justify-between">
                                    <Link
                                        to="/sub"
                                        className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-md transition-colors"
                                    >
                                        Keep Subscription
                                    </Link>

                                    <button
                                        type="submit"
                                        disabled={processing || !id}
                                        className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {processing ? (
                                            <span className="flex items-center">
                                                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                                Processing...
                                            </span>
                                        ) : (
                                            "Cancel Subscription"
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <div className="text-center py-8">
                            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                                <svg className="h-6 w-6 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            <h3 className="mt-2 text-lg font-medium text-gray-900">Subscription Canceled</h3>
                            <p className="mt-1 text-sm text-gray-500">
                                Your subscription has been successfully canceled. You'll still have access until the end of your current billing period.
                            </p>
                            <div className="mt-6">
                                <Link
                                    to="/sub"
                                    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                >
                                    Return to Subscriptions
                                </Link>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CancelSubscription;
